<template>
  <div class="field">
    <input ref="calendar" type="date" class="input" />
  </div>
</template>

<script>
import bulmaCalendar from "@/utils/bulma-calendar.min.js";
import { getId } from "@/utils/document";
import moment from "moment";

export default {
  props: { startDate: Date, startTime: Date, type: String, minDate: Date },
  data() {
    return {
      id: getId(),
    };
  },
  created() {},
  mounted() {
    this.init();
  },
  methods: {
    init() {
      const hours = this.startTime ? moment(this.startTime).format("HH") : "18";
      const minutes = this.startTime
        ? moment(this.startTime).format("mm")
        : "00";

      let time = new Date();
      time = new Date(time.setHours(hours));
      time = new Date(time.setMinutes(minutes));
      time = new Date(time.setMilliseconds(0));

      let date = this.startDate ? this.startDate : new Date();
      date = new Date(date.setHours(0));
      date = new Date(date.setMinutes(0));
      date = new Date(date.setMilliseconds(0));      

      const calendar = bulmaCalendar.attach(this.$refs.calendar, {
        startDate: date,
        timeFormat: "HH:mm",
        startTime: time,
        minDate: this.minDate || date,
        weekStart: 1,
        showTodayButton: false,
        showClearButton: false,
        displayMode: "dialog",
        type: this.type || "date",
        validateLabel: "Set",
      })[0];

      this.$nextTick(() => {
        if (this.type === "time") {
          this.$refs.calendar.bulmaCalendar.timePicker._time.start = time;
          this.$refs.calendar.bulmaCalendar.timePicker._ui.start.hours.number.innerHTML = hours;
          this.$refs.calendar.bulmaCalendar.timePicker._ui.start.minutes.number.innerHTML = minutes;
          this.$refs.calendar.parentElement.childNodes[1].value = `${hours}:${minutes}`;
        }
      });

      let toEmit;
      if (this.type === "time") {
        toEmit = new Date(time.toISOString());
      }

      if (!this.type || this.type === "date") {
        toEmit = new Date(date.toISOString());
      }

      this.$emit("selected", toEmit);

      calendar.on("select", (cal) => {
        let toEmit;

        if (this.type === "time")
          toEmit = new Date(cal.data.startTime.toISOString());
        if (!this.type || this.type === "date")
          toEmit = new Date(cal.data.startDate.toISOString());

        this.$emit("selected", toEmit);
      });
    },
  },
};
</script>
